import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';

import FilterGroup from './filter-group';
import { getNewOrders } from '../../../actions/orders';

import './style.css';
class Filters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      categories: [],
      new: null,
      featured: null,
      reward: null
    };
  }

  componentDidMount() {
    if (this.props.preFilteredCategories) {
      this.setState({
        categories: this.props.preFilteredCategories
      });
    }
  }

  clearFilters = () => {
    this.setState({
      categories: [],
      new: null,
      featured: null,
      reward: null
    }, this.filterData);
  };

  filterData = () => {
    let q = {
      category_ids: this.state.categories,
      special_new: this.state.new,
      special_featured: this.state.featured,
      special_reward: this.state.reward
    };

    this.props.dispatch(getNewOrders(q));
  };

  setCategories = (values) => {
    this.setState({
      categories: values
    }, () => {
      this.props.filterCategories(values)
    });
  };


  setSpecials = (values) => {
    let newState = {
      featured: null,
      new: null,
      reward: null
    };

    values.forEach(curr => {
      if (curr === 1) {
        newState.featured = true;
      } else if (curr === 2) {
        newState.new = true;
      } else if (curr === 3) {
        newState.reward = true;
      }
    });

    this.setState(newState, this.filterData);
  };

  render() {
    return (
      <div className="product-filters">
        <Grid fluid className='product-filter-list' >
          <Row>
            <Col lg={12}>
              <FilterGroup filterType="categories"
                           className="categories-group"
                           idKey="catogories"
                           values={this.state.categories}
                           onchange={this.setCategories} />
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

export default connect()(Filters);



// WEBPACK FOOTER //
// ./src/components/new-order/filters/filters.jsx